"use strict";
module.exports = ['$rootScope', '$translate', '$http', '$httpParamSerializer', function ($rootScope, $translate, $http, $httpParamSerializer) {
        // console.log(base64);
        var _conf = require('../../package.json');
//        // var _baseUrl = 'http://ext.aslcn1.it:8080/';
//        //var _baseUrl = 'http://192.168.2.113:8080/';          //test DORMEDIAN    
//        var _baseUrl = '/';                                     //ambiente ASTRAL
//       //     var _baseUrl = 'http://192.168.2.30:8080/';
//        var _prefix = 'uaa/';
//        var _usePrefix = false;

        var mainConfig = $rootScope.configs.ngDroUAAMainConfig;

        this.getUrl = function (method) {
            //var url = _baseUrl;
//            if (_usePrefix) {
//                url += _prefix;
//            }
            var url = mainConfig.BaseUrl;
            if (mainConfig.UsePrefix) {
                url += mainConfig.Prefix;
            }
            if (typeof method === 'string') {
                url += method;
            }
            return url;
        };

        this.version = function () {
            $translate('uaa.version').then(function (translated) {
                console.log(translated, _conf.version);
            }, function (translationId) {
                console.log(translationId, _conf.version);
            });
        };

        this.setPrefix = function (prefix) {
            mainConfig.Prefix = prefix;
            //_prefix = prefix;
            return this;
        };

        this.getPrefix = function () {
//            _prefix = prefix;
//            return _prefix;
            return  mainConfig.Prefix;
        };

        this.setBaseUrl = function (baseUrl) {
            //_baseUrl = baseUrl;
            mainConfig.BaseUrl = baseUrl;
            return this;
        };

        this.getBaseUrl = function () {
//            _baseUrl = baseUrl;
//            return _baseUrl;
            return mainConfig.BaseUrl;
        };

        this.setUsePrefix = function (usePrefix) {
            //_usePrefix = usePrefix;
            mainConfig.UsePrefix = usePrefix;
            return this;
        };
    }];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/UAACommon.js
// module id = 392
// module chunks = 0